// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const deleteStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("State ID"),
});

export const deleteStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State deleted successfully
 */
export const deleteState200Schema = z.object({});

/**
 * @description Access denied - admin required or system managed state
 */
export const deleteState403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description State not found
 */
export const deleteState404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteStateMutationResponseSchema = z.lazy(() => deleteState200Schema);
